// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--1JcfmCjf5"};